<template>
  <div class="live_stream_container">
    <Sticky>
      <NavBar />
      <TabBar :tabDate="tabDate" @upTab="upTab" />
    </Sticky>
    <div class="broad_list">
      <PullToRefresh v-model:refreshing="refreshing" @refresh="onRefresh" :min-height="pullRefreshHeight">
        <template v-if="listData.length > 0">
          <List
            v-model:loading="loading"
            :finished="finished"
            :finished-text="listData && listData.length > pageSize ? `-  ${$t('app_class_room_bottom')} -` : ' '"
            @load="onLoad"
          >
            <template v-for="item in listData" :key="item.id">
              <div class="list_wrapper">
                <div class="list_item" @click="watchLiveStream(item)">
                  <div class="list_tag">
                    <span v-if="item.status === 1" class="no_end">{{ $t('app_in_live') }}</span>
                    <span v-else-if="item.status === 2" class="is_end">{{ $t('app_not_started') }}</span>
                    <span v-else class="is_end">{{ $t('app_ended') }}</span>
                    <div class="item_img">
                      <img class="img" :src="item.coverFileUrl" v-if="item.coverFileUrl" alt="" />
                      <img class="img" src="@/assets/images/live_stream.jpg" v-else alt="" />
                    </div>
                  </div>

                  <div class="item_content">
                    <p class="content_title">{{ item.name }}</p>
                    <p class="content_author">{{ item.lecturerName }}</p>
                    <p class="content_time">{{ item.startTime }}</p>
                  </div>

                  <span class="item_btn" v-if="item.status === 1 || item.status === 2">
                    {{ $t('app_live_stream_watch') }}
                  </span>
                  <!-- 回放 -->
                  <span
                    class="item_btn item_btn1"
                    v-if="item.status === 3 && item.isAllowPlayback === 1 && item.coursewareId"
                  >
                    {{ $t('app_live_stream_playback') }}
                  </span>
                  <!-- 回访生成中 -->
                  <span class="item_btn item_btn2" v-if="item.status === 3 && !item.coursewareId">
                    {{ $t('app_live_stream_playback') }}
                  </span>
                </div>
              </div>
            </template>
            <template #loading>
              <Loading type="spinner" v-if="listData && listData.length > pageSize" />
              <span v-else>{{ ' ' }}</span>
            </template>
          </List>
        </template>
        <Error v-else :selfStyle="{ backgroundColor: '#fff', width: '100%' }" />
      </PullToRefresh>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import NavBar from '@/components/NavBar.vue'
import TabBar from '@/components/TabBar.vue'
import { Sticky, List, showToast, Loading } from 'vant'
import { getLivestreamList, getLivestreamRedirect } from '@/api/requests/LiveStream'
import PullToRefresh from '@/components/PullToRefresh.vue'
import { Record } from '@/api/Models/LiveRoomList'
import Error from '@/components/Error.vue'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { isFeishu } from '@/utils/feishu'
import { isApp } from '@/utils/client'
import { isWechat } from '@/utils/weixin'
import { isTudoApp } from '@/utils/tudo'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isOutFieldApp } from '@/utils/outfield'
import { isBranchManagerApp } from '@/utils/sandsTalkBranchManager'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { isSandsTalkMiddleEastApp } from '@/utils/sandsTalkMEOutfiled'
import { isSandsTalkBrMexApp } from '@/utils/sandsTalkBRMXOutfiled'

const { t } = useI18n()
const router = useRouter()
const themeColor = useThemeColor()

const tabDate = ref([
  { title: t('app_all'), name: null },
  { title: t('app_in_live'), name: 1 },
  { title: t('app_not_started'), name: 2 },
  { title: t('app_ended'), name: 3 }
])
const status = ref()
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const current = ref(1)
const total = ref(0)
const pageSize = ref(15)
const listData = ref<Record[]>([])

const liveStreamList = async () => {
  const res = await getLivestreamList({
    current: current.value,
    keyWord: '',
    size: pageSize.value,
    status: status.value
  })
  if (refreshing.value) {
    refreshing.value = false
  }
  const { code, data } = res
  loading.value = false
  if (code === 1) {
    if (current.value === 1) {
      total.value = Math.ceil(data.total / pageSize.value)
      listData.value = data.records
    } else {
      listData.value.push(...data.records)
    }
    if (current.value >= total.value) {
      finished.value = true
    } else {
      current.value++
    }
  }
}

const onLoad = () => {
  liveStreamList()
}

const onRefresh = () => {
  finished.value = false
  loading.value = true
  current.value = 1
  liveStreamList()
}

const upTab = (name: number) => {
  status.value = name
  onRefresh()
}

onMounted(() => {
  liveStreamList()
})

// 直播/回放/回放生成中
const watchLiveStream = async (item: Record) => {
  const isPlayback = item.status === 3 && item.coursewareId
  const isPlaybackGenerating = item.status === 3 && !item.coursewareId
  const isLiveStream = item.status === 1 || item.status === 2
  if (isLiveStream) {
    router.push({ name: 'live', query: { watchUrl: item.watchUrl } })
  }
  try {
    const res = await getLivestreamRedirect({
      id: item.id,
      type: 0
    })
    if (res) {
      if (isPlayback) {
        if (item.isAllowPlayback === 1) {
          // 回放状态 跳转课件
          router.push({
            name: 'courseDetail',
            query: {
              id: item.coursewareId,
              courseType: 'courseWare',
              channel: 5,
              title: item.name
            }
          })
          return
        }
      }
      if (isPlaybackGenerating) {
        if (item.isAllowPlayback === 1) {
          showToast(t('app_live_stream_replay_generation'))
          return
        }
        if (item.isAllowPlayback === 0) {
          return
        }
      }
    } else {
      // 你还没有该直播间的访问权限，请向管理员申请
      showToast(t('app_no_live_stream_permission'))
      router.replace({ path: '/empty', query: { msg: t('app_no_live_stream_permission') } })
    }
  } catch (error) {
    console.log(error, 'error')
  }
}

const pullRefreshHeight =
  !isFeishu &&
  !isApp &&
  !isWechat &&
  !isTudoApp &&
  !isWisdomRabbitApp &&
  !isOutFieldApp &&
  !isBranchManagerApp &&
  !isSandsTalkFlutterApp &&
  !isSandsTalkMSFlutterApp &&
  !isSandsTalkPhOutfieldApp &&
  !isSandsTalkMiddleEastApp &&
  !isSandsTalkBrMexApp
    ? 'calc(100vh - 88px)'
    : 'calc(100vh - 44px)'
</script>
<script lang="ts">
export default {
  name: 'liveStream'
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.live_stream_container {
  background-color: @contentBackground;
  overflow: hidden;
  .bottom_navigation;
  .van-pull-refresh {
    padding: 0 12px;
  }
  .list_wrapper {
    .list_item {
      padding: 14px 0;
      display: flex;
      align-items: center;
      .border_1px_b;
      .item_img {
        width: 96px;
        height: 54px;
        border-radius: 5px;
        overflow: hidden;
        .flex_center;
        .img {
          width: 100%;
        }
      }
      .item_content {
        flex: 1;
        margin-left: 10px;
        .content_title {
          font-size: 14px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-all; /* 添加换行规则 */
        }
        .content_author {
          color: @textNormal;
          font-size: 12px;
        }
        .content_time {
          margin-top: 4px;
          color: @textSecondary99;
          font-size: 12px;
        }
      }
      .item_btn {
        // width: 61px;
        min-width: 61px;
        padding: 0 10px;
        height: 28px;
        background-color: v-bind(themeColor);
        border-radius: 28px;
        .flex_center;
        color: @textWhite;
        font-size: 13px;
      }
      .item_btn1 {
        background-color: #fff;
        border: 1px solid v-bind(themeColor);
        color: v-bind(themeColor);
      }
      .item_btn2 {
        background-color: #f4f5f7;
        color: #999999;
      }
      .list_tag {
        position: relative;
        span {
          position: absolute;
          top: 0; /* 调整标签的垂直位置 */
          right: 0; /* 调整标签的水平位置 */
          color: white; /* 调整标签的文字颜色 */
          font-size: 12px; /* 调整标签的字体大小 */
          zoom: 0.6;
          padding: 5px;
          z-index: 1; /* 确保标签在图片上方显示 */
          border-bottom-left-radius: 5px;
          border-top-right-radius: 5px;
        }
        .no_end {
          background: v-bind(themeColor);
        }
        .is_end {
          background-color: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
}
</style>
